var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Pausenplan'),(_vm.isReleaseCandidate)?_c('div',{staticClass:"release-candidate-badge",attrs:{"title":"Release Candidate","aria-label":"Release Candidate"}},[_c('span',{staticClass:"release-candidate-dot",attrs:{"aria-hidden":"true"}}),_vm._v("RC ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }